export default __webpack_public_path__ + "static/1484-24790a957df54c2c71fb9f6ba626c140.gif";